import React, { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ACCESS_TOKEN } from 'shared/constant';
import Layout from 'layouts/Layout';

export const PrivateRoute = (props: { children: JSX.Element }): JSX.Element => {
  const accessToken = localStorage.getItem(ACCESS_TOKEN);
  // const isAuthenticated = useSelector((state: any) => state.user?.authenticated);


  // Check authentication
  if (!accessToken) {
    return <Navigate to="/sign-in" />;
  }

  return <Layout>{props.children}</Layout>;
};
